"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFilterOptions = exports.FilterVocabulary = void 0;
var FilterVocabulary;
(function (FilterVocabulary) {
    FilterVocabulary["UNCATEGORIZED_NAME"] = "Uncategorized";
    FilterVocabulary["UNLIMITED"] = "Unlimited";
    FilterVocabulary["BUNDLED_DISCOUNTS"] = "Bundled discounts";
})(FilterVocabulary || (exports.FilterVocabulary = FilterVocabulary = {}));
var SortFilterOptions;
(function (SortFilterOptions) {
    SortFilterOptions["A_Z"] = "Alphabetically, A - Z (default)";
    SortFilterOptions["Z_A"] = "Alphabetically, Z - A";
    SortFilterOptions["PRICE_LOW_HIGH"] = "Price, Low to High";
    SortFilterOptions["PRICE_HIGH_LOW"] = "Price, High to Low";
    SortFilterOptions["ABV_LOW_HIGH"] = "ABV, Low to High";
    SortFilterOptions["ABV_HIGH_LOW"] = "ABV, High to Low";
    SortFilterOptions["PROOF_LOW_HIGH"] = "Proof, Low to High";
    SortFilterOptions["PROOF_HIGH_LOW"] = "Proof, High to Low";
    SortFilterOptions["THC_LOW_HIGH"] = "THC, Low to High";
    SortFilterOptions["THC_HIGH_LOW"] = "THC, High to Low";
    SortFilterOptions["CBD_LOW_HIGH"] = "CBD, Low to High";
    SortFilterOptions["CBD_HIGH_LOW"] = "CBD, High to Low";
    SortFilterOptions["PG_LOW_HIGH"] = "PG, Low to High";
    SortFilterOptions["PG_HIGH_LOW"] = "PG, High to Low";
    SortFilterOptions["VG_LOW_HIGH"] = "VG, Low to High";
    SortFilterOptions["VG_HIGH_LOW"] = "VG, High to Low";
    SortFilterOptions["NICOTINE_STRENGTH_LOW_HIGH"] = "Nicotine Strength, Low to High";
    SortFilterOptions["NICOTINE_STRENGTH_HIGH_LOW"] = "Nicotine Strength, High to Low";
})(SortFilterOptions || (exports.SortFilterOptions = SortFilterOptions = {}));
//# sourceMappingURL=vocabularies.js.map